import styled from "styled-components";

export const AppBuyListStyle = {
  Message: styled.div``,
  Container: styled.div`
    padding: 24px 16px;
    background: #f7f7f7;

    .container-top-message {
      color: #000000;
      font-size: 12px;
      margin-bottom: 24px;
      line-height: 16px; /* 133.333% */
      a {
        color: #6094fa;
        text-decoration: underline;
      }
    }
  `,
  Card: styled.div`
    padding: 24px;
    border-radius: 16px;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 6px 12px -6px rgba(0, 0, 0, 0.04),
      0 8px 24px -4px rgba(0, 0, 0, 0.04);
    margin-bottom: 8px;
    .badge {
      display: flex;
      width: max-content;
      height: 20px;
      padding: 0 8px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      color: #fff;
      font-size: 10px;
      font-weight: 500;
      line-height: 16px; /* 160% */
      letter-spacing: -0.2px;
      border-radius: 20px;
      background: linear-gradient(90deg, #cd3ec7 0%, #5328df 50%, #2d8efa 100%);
      &.purple {
        background: #6d2ef2;
        color: #fff;
      }
      &.gray {
        background: #888;
        color: #fff;
      }
      &.orange {
        background: #f40;
        color: #fff;
      }
    }
    .outline-badge {
      display: flex;
      height: 20px;
      padding: 0 8px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 20px;
      border: 1px solid var(--gray-scale-gray-100, #eee);
      color: var(--gray-scale-gray-400, #666);
      text-align: center;
      font-family: Pretendard;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 160% */
      letter-spacing: -0.2px;
      width: max-content;
    }
    h3 {
      color: #212121;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px; /* 150% */
      margin-top: 8px;
      margin-bottom: 16px;
    }
    .kv {
      display: flex;
      padding: 4px 0;
      > :first-child {
        width: 72px;
        color: #555;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px; /* 133.333% */
        letter-spacing: -0.36px;
      }
      > :last-child {
        color: #666;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px; /* 133.333% */
        letter-spacing: -0.24px;
      }
      &.purple {
        > span {
          color: #6d2ef2;
        }
      }
    }
    .price {
      display: flex;
      margin-top: 16px;
      padding: 16px 0;
      justify-content: flex-end;
      align-items: center;
      align-self: stretch;
      border-top: 1px solid var(--gray-scale-gray-100, #eee);
      color: var(--gray-scale-gray-900, #212121);
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 140%; /* 28px */
    }
    .btns {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      flex: 1 0 0;
      button {
        color: var(--gray-scale-gray-400, #666);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.28px;
        display: flex;
        height: 32px;
        padding: 0 12px;
        justify-content: center;
        align-items: center;
        flex: 1 0 0;
        border-radius: 4px;
        border: 1px solid var(--gray-scale-gray-100, #eee);
        &.primary-btn {
          background: var(--primary-color, #6d2ef2);
          color: #fff;
          border: none;
          font-weight: 600;
        }
      }
    }
    .fail-msg {
      padding: 8px;
      border-radius: 8px;
      background: #fff5f2;
      .fail-title {
        > :last-child {
          color: var(--system-error, #f40);
          font-family: Pretendard;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; /* 200% */
          letter-spacing: -0.36px;
          margin-left: 2px;
        }
      }
      .fail-desc {
        color: var(--gray-scale-gray-600, #555);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 133.333% */
        letter-spacing: -0.24px;
        margin-left: 26px;
      }
    }
  `,
  Pagination: styled.div`
    display: flex;
    margin-top: 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    .prev-btn,
    .next-btn {
      display: flex;
      width: 48px;
      height: 24px;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 1px solid var(--neutral-neutral-200, #eee);
      background: var(--white, #fff);
    }
    .current-page {
      color: var(--neutral-neutral-900, #212121);
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
    }
    .divider {
      color: var(--neutral-neutral-300, #e0e0e0);

      /* font-web/body/small */
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
    }
    .total-page {
      color: var(--neutral-neutral-500, #9e9e9e);

      /* font-web/body/small */
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
    }
  `,
};
